import {
  GET_HOST_FAQS_START,
  GET_HOST_FAQS_SUCCESS,
  GET_HOST_FAQS_ERROR
} from '../constants';

export default function faqs(state = {}, action) {
  switch (action.type) {

    case GET_HOST_FAQS_SUCCESS:
      return {
        ...state,
        dataList: action.dataList,
        faqDescription: action.faqDescription
      };

    default:
      return state;
  }
}